export default {
      id: "checkmark-bold-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#checkmark-bold",
      toString: function () {
        return this.url;
      }
    }